// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/app/src/models/aliasNameContext';
import model_2 from '/app/src/models/candidateContext';
import model_3 from '/app/src/models/domainContext';
import model_4 from '/app/src/models/homePageContext';
import model_5 from '/app/src/models/influencerContext';
import model_6 from '/app/src/models/socialPageContext';
import model_7 from '/app/src/models/threadContext';
import model_8 from '/app/src/models/wikiPageContext';
import model_9 from '/app/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'aliasNameContext', model: model_1 },
model_2: { namespace: 'candidateContext', model: model_2 },
model_3: { namespace: 'domainContext', model: model_3 },
model_4: { namespace: 'homePageContext', model: model_4 },
model_5: { namespace: 'influencerContext', model: model_5 },
model_6: { namespace: 'socialPageContext', model: model_6 },
model_7: { namespace: 'threadContext', model: model_7 },
model_8: { namespace: 'wikiPageContext', model: model_8 },
model_9: { namespace: '@@initialState', model: model_9 },
} as const
